import React from 'react';

import './partners.styles.scss';

/* eslint-disable-next-line */
export interface PartnersProps {}

const partners = [
  require('../../../assets/photos/hopin-collaborators/next-canada.png'),
  require('../../../assets/photos/hopin-collaborators/dmz.png'),
  require('../../../assets/photos/hopin-collaborators/spark-centre.png'),
  require('../../../assets/photos/hopin-collaborators/yspace.png'),
];

export function Partners(props: PartnersProps) {
  return (
    <div className="partner pt-100 pb-70 bg-color">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">Partners</span>
          <h2>Innovation Hub Partners</h2>
        </div>

        <div className="row align-items-center">
          {partners.map((link, i) => (
            <div className="col-lg-3 col-6 col-sm-4 col-md-4" key={i}>
              <div
                className="single-partner-item wow fadeInUp"
                data-wow-delay={`0.${i}s`}
              >
                <img src={link} alt="about" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Partners;
